window.LHCChatOptions = {};
window.departmentChat = 2;
window.themeChat = 2;
window.surveyChat = 3;

export {};
